import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { List, ListItemButton, ListItemText, Paper } from '@mui/material';

export type BulletinMentionItem = { id: string; label: string };

export type BulletinMentionListProps = {
  items: BulletinMentionItem[];
  command: (item: BulletinMentionItem) => void;
};

/** TipTap メンション候補（キーボード操作用に ref で onKeyDown を公開） */
const BulletinMentionList = forwardRef<{ onKeyDown: (e: KeyboardEvent) => boolean }, BulletinMentionListProps>(
  function BulletinMentionList(props, ref) {
    const [selected, setSelected] = useState(0);

    useEffect(() => {
      setSelected(0);
    }, [props.items]);

    useImperativeHandle(ref, () => ({
      onKeyDown: (event: KeyboardEvent) => {
        if (!props.items.length) return false;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setSelected((i) => Math.min(i + 1, props.items.length - 1));
          return true;
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          setSelected((i) => Math.max(i - 1, 0));
          return true;
        }
        if (event.key === 'Enter') {
          event.preventDefault();
          const item = props.items[selected];
          if (item) props.command(item);
          return true;
        }
        return false;
      },
    }));

    return (
      <Paper elevation={8} sx={{ maxHeight: 280, overflow: 'auto', minWidth: 220 }}>
        <List dense disablePadding>
          {props.items.length === 0 ? (
            <ListItemButton disabled>
              <ListItemText primary="一致する職員がいません" />
            </ListItemButton>
          ) : (
            props.items.map((item, idx) => (
              <ListItemButton
                key={item.id}
                selected={idx === selected}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => props.command(item)}
              >
                <ListItemText primary={item.label} />
              </ListItemButton>
            ))
          )}
        </List>
      </Paper>
    );
  }
);

export default BulletinMentionList;
